{
  "pages": {
    "edit": "Édition de la manifestation",
    "signing_sheet": "Signature électronique",
    "history": "Historique"
  },
  "edit": {
    "contract_management_link": "Gestion des contrats"
  },
  "tabs": {
    "indications": "Informations",
    "planned_attendees": "Invités prévus",
    "planned_benefits": "Avantages prévus",
    "contract_generation": "Génération des contrats",
    "signing": "Signature",
    "submission": "Dépôt",
    "attendance_sheet": "Émargement",
    "actual_expenses_attendees": "Participants/Dépenses réelles"
  },
  "new": {
    "title": "Création d'un évènement",
    "subtitle": "Précisez les informations requises sur l'évènement.",
    "layout": {
      "backLink": "Retour au tableau de bord",
      "title": "Ajouter un évènement "
    },
    "mandatory_notice": "Les champs obligatoires sont marqués d'un *",
    "no_results": "Aucun résultat",
    "input": {
      "legends": {
        "main": "Création de la manifestation",
        "main_edit": "Édition de la manifestation",
        "tab_attachments": "Pièces jointes",
        "tab_general_informations": "Informations générales",
        "identifications": "Identifications",
        "coordinates": "Adresse",
        "details": "Détails",
        "dates": "Dates",
        "parameters": "Paramètres",
        "attachments": "Pièces jointes",
        "links": "Liens",
        "allocations": "Rattachements",
        "connectors": "Connecteurs"
      },
      "errors": {
        "name": "Le champ nom est requis",
        "internal_code": "Le champ code interne est requis",
        "event_type": "Le champ manifestation est requis",
        "workflow": {
          "connect": "Le champ workflow est requis"
        },
        "address": {
          "city": "Le champ ville est requis",
          "street_name": "Le champ adresse est requis",
          "postcode": "Le champ code postal est requis"
        },
        "initiator": "Le champ initiateur est requis",
        "validator_1": "Le champ validateur 1 est requis",
        "validator_2": "Le champ validateur 2 est requis",
        "attachments": "Veuillez uploader au moins un fichier joint."
      },
      "event_type": "Type de manifestation",
      "event_types": {
        "EVENT": "Évènement déclaré",
        "SIMPLE_EVENT": "Évènement simplifié",
        "UNDECLARED_EVENT": "Évènement non déclaré",
        "DONATION": "Don",
        "SIMPLE_DECLARATION": "Déclarations simplifiées",
        "CONTRACT": "Contrat"
      },
      "operation_type_transparency": "Type d’opération Transparence Santé",
      "operation_types_transparency": {
        "DOCUMENTATION_PURCHASE": "Achat de documentation scientifique",
        "SCIENTIFIC_MANIFESTATION_SPACE_PURCHASE_LEASE": "Contrat d’achat ou de location d’espaces dans le cadre de manifestations scientifiques",
        "ADVERTISEMENT_SPACE_PURCHASE_LEASE": "Contrat d’achat ou de location d’espaces publicitaires",
        "SCIENTIFIC_EXPERT_CONTRACT": "Contrat d’expert scientifique",
        "SCIENTIFIC_RESEARCH_CONTRACT": "Contrat de recherche scientifique",
        "SCIENTIFIC_EVALUATION_CONTRACT": "Contrat d’évaluation scientifique",
        "EXPERTISE_CONSULTING_CONTRACT_OTHER_THAN_SCIENTIFIC": "Contrat de conseil / d’expertise autre que scientifique",
        "INQUIRY_MARKET_STUDY_EXCLUDING_RESEARCH": "Enquête, étude, étude de marché (hors recherche)",
        "PARTICIPATION_CONTRACT_IN_AN_EVENT": "Contrat de participation à une manifestation",
        "EVENT_SPEAKER_CONTRACT": "Contrat d’intervenant à une manifestation",
        "TRAINING_CONTRACT": "Formation",
        "RESEARCH_GRANT_CONTRACT": "Contrat de remise d’une bourse de recherche",
        "AWARD_CONTRACT": "Contrat de remise de prix",
        "INTERVIEW_CONTRACT": "Contrat d’interview",
        "SPONSORSHIP": "Mécénat",
        "PATRONAGE": "Parrainage",
        "PARTNERSHIP": "Partenariat",
        "RIGHTS_TRANSFER_LICENSE": "Cession de droits / licence d’exploitation",
        "PUBLISHING_CONTRACT": "Edition",
        "COSMETIC_PRODUCT_EVALUATION": "Evaluation produit cosmétique",
        "COSMETIC_PRODUCT_VIGILANCE": "Vigilance produit cosmétique",
        "OTHER": "Autre",
        "NOT_APPLICABLE": "Non applicable"
      },
      "operation_type_eps": "Type d’opération EPS",
      "operation_types_eps": {
        "AWARD_CONTRACT": "Contrat de remise de prix",
        "ADVERTISING_SPACE_PURCHASE_OR_RENTAL_CONTRACT": "Contrat d'achat ou de location d'espaces publicitaires",
        "CONTRACT_FOR_THE_PURCHASE_OR_RENTAL_OF_SPACES_AS_PART_OF_SCIENTIFIC_EVENTS": "Contrat d'achat ou de location d'espaces dans le cadre d'évènements scientifiques",
        "SCIENTIFIC_EVALUATION_CONTRACT": "Contrat d'évaluation scientifique",
        "EVENT_SPEAKER_CONTRACT": "Contrat d'intervenant à une manifestation",
        "SCIENTIFIC_RESEARCH_CONTRACT_EXPERTISE_CONSULTANT": "Contrat de recherche scientifique (expert, consultant)",
        "CONSULTING_OR_EXPERTISE_CONTRACT_OTHER_THAN_SCIENTIFIC_SURVEY_STUDY_MARKET_STUDY": "Contrat de conseil ou d’expertise autre que scientifique (enquête, étude, étude de marché)",
        "RESEARCH_GRANT_AWARD_CONTRACT": "Contrat de remise d'une bourse de recherche",
        "CONFERENCE_REGISTRATION_CONTRACT": "Contrat d'inscription aux congrès",
        "PATRONAGE": "Mécénat",
        "SPONSORSHIP": "Parrainage",
        "PARTNERSHIP": "Partenariat",
        "OTHER": "Autres"
      },
      "operation_type_idahe": "Type de manifestation IDAHE",
      "operation_types_idahe": {
        "CONGRESS": "Congrès",
        "GRADUATE_EDUCATION": "Formation diplômante",
        "INVESTIGATOR_MEETING": "Réunion investigateur",
        "PROFESSIONAL_MEETING": "Réunion professionnelle",
        "WEEKEND_SEMINAR": "Séminaire fin de semaine",
        "TRAINING_COURSE": "Stage de formation",
        "LABORATORY_SYMPOSIUM": "Symposium laboratoire",
        "FACTORY_VISIT": "Visite d'usine",
        "AGREEMENT_2020_0101": "Convention n°2020/01-01",
        "AGREEMENT_2020_0102": "Convention n°2020/01-02",
        "AGREEMENT_2020_02": "Convention n°2020/02",
        "AGREEMENT_2020_0301": "Convention n°2020/03-01",
        "AGREEMENT_2020_0302": "Convention n°2020/03-02",
        "AGREEMENT_2020_0401": "Convention n°2020/04-01",
        "AGREEMENT_2020_0402": "Convention n°2020/04-02",
        "AGREEMENT_2020_05": "Convention n°2020/05",
        "AGREEMENT_2024_01": "Convention n°2024/01",
        "AGREEMENT_2024_02": "Convention n°2024/02",
        "AGREEMENT_2024_03": "Convention n°2024/03",
        "AGREEMENT_2024_04": "Convention n°2024/04",
        "AGREEMENT_2024_05": "Convention n°2024/05",
        "OTHER": "Autre"
      },
      "event_specialty": {
        "label": "Spécialité",
        "ALLERGOLOGY": "Allergologie",
        "ANATOMICAL_PATHOLOGY": "Anatomopathologie",
        "ANGIOLOGY": "Angiologie",
        "MEDICAL_BIOLOGY": "Biologie médicale",
        "CARDIOLOGY": "Cardiologie",
        "MAXILOFACIAL_SURG": "Chir maxillo-faciale stomato",
        "CARDIOVASCULAR_SURG": "Chir thoracique et cardiovasc",
        "VISCERAL_SURG": "Chir viscérale et digestive",
        "SURGERY": "Chirurgie",
        "FACE_SURG": "Chirurgie de la face et du cou",
        "INFANT_SURG": "Chirurgie infantile",
        "ORTHOPEDIC_SURG": "Chirurgie orthopédique",
        "PLASTIC_SURG": "Chirurgie plast. rec. esth.",
        "UROLOLOGIC_SURG": "Chirurgie urologique",
        "VASCULAR_SURG": "Chirurgie vasculaire",
        "DERMATOLOGY": "Dermatologie",
        "PROFESSIONAL_DVPT": "DPC et divers",
        "ENDOCRINOLOGY": "Endocrinologie",
        "GASTROENTEROLOGY": "Gastroentérologie",
        "GENETICS": "Génétique",
        "GERIATRICS": "Gériatrie",
        "MEDICAL_GYNECOLOGY": "Gynécologie médicale",
        "OBSTETRIC_GYNECOLOGY": "Gynécologie obstétrique",
        "HEMATOLOGY": "Hématologie",
        "INFECTIOLOGY": "Infectiologie",
        "READAPT_MEDICINE": "Méd phys et de réadaptation",
        "EMERGENCY_MEDICINE": "Médecine d'urgence",
        "SPORT_MEDICINE": "Médecine du sport",
        "WORK_MEDICINE": "Médecine du travail",
        "GENERAL_MEDICINE": "Médecine générale",
        "INTERN_MEDICINE": "Médecine interne",
        "NUCLEAR_MEDICINE": "Médecine nucléaire",
        "THERMAL_MEDICINE": "Médecine thermale",
        "MULTIDISCIPLINARY": "Multi-disciplinaire",
        "NEPHROLOGY": "Néphrologie",
        "NEUROSURGERY": "Neurochirurgie",
        "NEUROLOGY": "Neurologie",
        "NONE": "Aucune",
        "ONCOLOGY": "Oncologie",
        "OPHTALMOLOGY": "Ophtalmologie",
        "ORL": "ORL",
        "PEDIATRICS": "Pédiatrie",
        "PHARMACOLOGY": "Pharmacologie",
        "PNEUMOLOGY": "Pneumologie",
        "PSYCHIATRY": "Psychiatrie",
        "MEDICAL_IMAGERY": "Radiodiag et imagerie médicale",
        "RADIOLOGY": "Radiologie opt. radio-thérap.",
        "ANESTHESIA": "Réa médicale - Anesthésie",
        "MEDICAL_RESEARCH": "Recherche médicale",
        "RHEUMATOLOGY": "Rhumatologie",
        "PUBLIC_HEALTH": "Santé publique et méd sociale",
        "STOMATOLOGY": "Stomatologie",
        "LOCAL_TRAINING_ORG": "Structure de FMC locale",
        "TRANSPLANT": "Transplantation"
      },
      "code": "Code interne",
      "quantity": "Nombre évènements",
      "operation": "Type d'opération",
      "event_workflow": "Type de workflow",
      "event_name": "Nom de la manifestation",
      "creator": "Créateur",
      "event_description": "Description",
      "event_description_verbose": "Description de l'évènement",
      "mission_goal": "Objet de la mission",
      "theme": "Thème",
      "place": "Lieu de l'évènement",
      "street_name": "Adresse de l'évènement",
      "country": "Pays",
      "city": "Ville",
      "postcode": "Code postal",
      "event_date_range": "Date, heure de début et de fin.",
      "event_date_range_contract": "Date, heure de début et de fin de contrat.",
      "event_date_range_open_period": "Date, heure de début et de fin de période couverte.",
      "event_initiator": "Initiateur",
      "event_validator_1": "Validateur 1",
      "event_validator_2": "Validateur 2",
      "event_internal_code": "Code interne",
      "simple_event_link": "Évènement(s) simplifié(s)",
      "event_link": "Évènement(s) déclaré(s)",
      "contract_link": "Contrat(s)",
      "simple_declaration_link": "Déclaration simplifiée",
      "undeclared_event_link": "Évènement(s) non déclaré(s)",
      "ticket_name": {
        "label": "Nom de la requête",
        "placeholder": "Nom de la requête"
      },
      "internal_tracking_code_name": {
        "label": "Code interne",
        "placeholder": "Code interne"
      },
      "start_at": {
        "label": "Date de début prévu",
        "placeholder": "Choisir une date",
        "now_button": "Aujourd'hui"
      },
      "end_at": {
        "label": "Expected release date"
      },
      "products": "Produit(s)",
      "product": "Produit",
      "sectors": "Secteur",
      "therapeutic_areas": "Aire thérapeutique",
      "units": "Service",
      "regions": "Région",
      "networks": "Réseau",
      "ugas": "UGA",
      "zones": "Zone",
      "identities": "Entité",
      "attachments": {
        "drag_and_drop_statement": "Veuillez téléverser un programme scientifique et/ou un bulletin d’inscription, un carton d’invitation, une lettre valant convention",
        "or_statement": "JPG, PNG, XLSX, PDF or DOC, pas plus de 128Mo",
        "cta_label": "Sélectionner un fichier",
        "input_type": "Liste de types",
        "input_comment": "Commentaires",
        "placeholder": "Ajoutez un commentaire ici",
        "file_type_description": "Veuillez renseigner le type de fichier joint",
        "file_type": "Type de fichier joint",
        "upload_doc": "Téléverser votre document",
        "comments": "Commentaires",
        "validate": "Valider",
        "error": {
          "default": "Une erreur s'est produite veuillez réessayer plus tard."
        },
        "types": {
          "REGISTRATION_FORM": "Bulletin d’inscription",
          "INVITATION_CARD": "Carton d’invitation",
          "QUOTATION": "Devis",
          "CONVENTION_LETTER": "Lettre valant convention",
          "MANDATE": "Mandat",
          "EVENT_PROGRAM": "Programme de la manifestation",
          "SCIENTIFIC_PROGRAM": "Programme scientifique",
          "OBSERVATION_BOOKLET_PROJECT": "Projet de cahier d’observation/recueil de données",
          "SUMMARY": "Résumé (en français)",
          "OTHERS": "Autre",
          "CONTRACT_PROJECT": "Projet de contrat",
          "SOLICITATION_LETTER": "Lettre de sollicitation",
          "ORDER_NOTICE": "Avis Ordre"
        },
        "listHeader": {
          "filename": "Nom du fichier",
          "period": "Période",
          "type": "Type",
          "created_at": "Créé le (UTC+0)",
          "action": "Actions",
          "at": "à"
        }
      },
      "address": {
        "label": "Lieu de l'évènement",
        "placeholder": "Lieu de l'évènement"
      },
      "attendees_import": {
        "download_template_ans": "Veuillez télécharger le template d'import RPPS avant de téléverser vos invités",
        "download_template_manual": "Veuillez télécharger le template d'import manuel avant de téléverser vos invités",
        "drag_and_drop_statement_ans": "Veuillez téléverser votre excel de liste d’invités pour l'import RPPS",
        "drag_and_drop_statement_manual": "Veuillez téléverser votre excel de liste d’invités pour l'import manuel",
        "drag_and_drop_statement": "Veuillez téléverser votre liste d’invités via le modèle Excel fourni",
        "or_statement": "XLSX",
        "cta_label": "Sélectionner un fichier",
        "duplicates": "L'/les invité(s) { fullNames } existe(nt) déjà."
      },
      "attendee_template_type": {
        "label": "Type d'import",
        "ANS": "import d’invité via le numéro RPPS",
        "MANUAL": "import d’invité manuel"
      },
      "manager_crm": "Gestionnaire CRM",
      "approver_crm": "Approbateur CRM",
      "with_agency": "Avec agence",
      "agency_name": "Nom de l'agence",
      "format": {
        "label": "Format",
        "ONSITE": "Présentiel",
        "DIGITAL": "Visioconférence",
        "HYBRID": "Hybride"
      },
      "meeting_type": {
        "label": "Type de réunion",
        "LOCAL": "Locale",
        "REGIONAL": "Régionale",
        "NATIONAL": "Nationale"
      },
      "external_code": "Référence CRM",
      "crm_manager": "Gestionnaire CRM",
      "contractor": "Contractant"
    },
    "tabs_header": {
      "event": "Indications",
      "attendees": "Invités",
      "advantages": "Avantages"
    },
    "button": {
      "save": "Enregistrer",
      "submit_and_go_to_next_step": "Enregistrer et passer à l'étape suivante",
      "submit_and_go_to_ticket_page": "Enregistrer et aller sur la page de l'évènement",
      "submit_and_send_for_validation": "Enregistrer et envoyer en validation",
      "submit_and_send_for_second_validation": "Enregistrer et envoyer en validation",
      "submit_and_send_back_to_initiator": "Renvoyer à l'initiateur pour modification",
      "submit_and_send_for_contract_management_stage": "Enregistrer et envoyer à l'étape gestion des contrats",
      "submit_and_send_for_event_validating": "Enregistrer et envoyer à l'étape de validation des dépenses",
      "submit_and_send_to_event_in_progress": "Déclarer l'évènement en cours",
      "submit_and_send_to_transparence_sante": "Envoyer en Transparence Santé",
      "validate_advantages": "Dépenses réelles complétées",
      "back_to_post_event": "Validation étape",
      "spending_complete": "Dépenses complétées",
      "spending_denied": "Dépenses non validées",
      "step_validated": "Étape validée",
      "archive_ticket": "Archiver le ticket"
    },
    "comment": {
      "placeholder": "Ajoutez votre commentaire",
      "step": "Commentaire ajouté à l'étape \"{step}\""
    },
    "modal": {
      "title": "Veuillez indiquer le motif de renvoi du ticket",
      "title_denying_advantage": "Veuillez indiquer le motif de refus des Avantages",
      "textarea": {
        "placeholder": "Ajoutez un commentaire"
      },
      "button": {
        "submit": "Ajouter",
        "cancel": "Annuler"
      }
    },
    "popup_modal": {
      "body": "Confirmez vous l’envoi de ce ticket en bibliothèque ?"
    },
    "toast": {
      "operation_change": "La modification du type d’opération entraînera la suppression des fichiers: {filenames}",
      "operation_change_with_mandatory_attachments": "La modification du type d’opération entraînera la suppression de l'ensemble des fichiers"
    }
  },
  "infos": {
    "code": "Numéro de dossier interne",
    "event_type": "Type",
    "name": "Nom",
    "operation": "Type d'opération",
    "address": {
      "street_name": "Adresse",
      "postcode": "Code postal",
      "city": "Ville",
      "country": "Pays"
    },
    "workflow": {
      "connect": "Type de workflow"
    },
    "initiator": "Initiateur",
    "validator_1": "Validateur 1",
    "validator_2": "Validateur 2",
    "place": "Lieu de l’évènement",
    "start_at": "Date de début",
    "end_at": "Date de fin",
    "created_at": "Date de création",
    "simple_declaration": {
      "connect": "Déclaration(s) simplifiée(s) liée(s)"
    },
    "simple_event_link": "Évènement(s) simplifié(s) lié(s)",
    "original_ticket_link": "Dossier source",
    "event_link": "Évènement déclaré lié",
    "contract_link": "Contrat(s) lié(s)",
    "undeclared_event_link": "Évènement(s) non déclaré(s) lié(s)",
    "description": "Description",
    "external_code": "Référence CRM",
    "quantity": "Nombre évènements",
    "manager_crm": "Gestionnaire CRM",
    "approver_crm": "Approbateur CRM",
    "agency_name": "Nom de l'agence",
    "createdBy": "Créé par",
    "therapeutic_areas": "Aire thérapeutique",
    "identities": "Entité",
    "units": "Service",
    "regions": "Région",
    "networks": "Réseau",
    "ugas": "UGA",
    "sectors": "Secteur",
    "zones": "Zone",
    "buttons": {
      "clone": "Dupliquer le ticket",
      "export_agency": "Export prévisionnel",
      "download_agency_export": "Télécharger le fichier",
      "export_agency_not_generated": "Aucun fichier généré",
      "export_agency_generated_at": "Fichier généré le: "
    }
  },
  "metadata": {
    "not_found": "N/A",
    "created_by": "Créé par",
    "created_at": "Créé le",
    "internal_number": "Numéro de dossier interne",
    "start_at": {
      "now_button": "Aujourd'hui",
      "label": "Début évènement",
      "placeholder": ""
    },
    "end_at": {
      "now_button": "Aujourd'hui",
      "label": "Fin évènement",
      "placeholder": ""
    }
  },
  "show": {
    "ticket_details": "Détails {eventType}",
    "waiting_for_edit": "En attente de modification",
    "waiting_for_validation": "En attente de validation",
    "tabs": {
      "general_informations": "Informations générales"
    }
  },
  "attendees": {
    "added_date": "Ajouté le",
    "api_down": "L'API est actuellement indisponible, veuillez réessayer plus tard.",
    "no_results": "Aucun résultat",
    "search_prompt": "Lancez une recherche pour afficher les résultats",
    "bulk_add_success": "{count} invité(s) ajouté(s) avec succès.",
    "bulk_add_partial": "{created} invité(s) ajouté(s), {errors} invité(s) déjà existant(s).",
    "bulk_add_failure": "Aucun invité n'a pu être ajouté, ils sont déjà existants.",
    "edit": "Édition d'invité",
    "contract_create": "Création d'un contrat via l'invité",
    "contact_create": "Créer le contact",
    "create": "Créer l'invité",
    "save": "Enregistrer les invités",
    "attendee_list": "Liste des invités",
    "search_from": "Rechercher",
    "health_directory": "Annuaire santé",
    "contact": "Contact",
    "manual_typing": "Saisie manuelle",
    "list_import": "Importer la liste",
    "list_import_history": "Historique d'import",
    "download_sign_off_sheet": "Télécharger la feuille d'émargement",
    "source": {
      "health_directory": {
        "label": "Annuaire santé",
        "description": "Professionnel de santé (RPPS)"
      },
      "contact": {
        "label": "Contact",
        "description": "Contacts enregistrés dans l'administration"
      },
      "veeva": {
        "label": "Veeva",
        "description": "Contacts enregistrés dans la base Veeva"
      },
      "one_key": {
        "label": "OneKey",
        "description": "Contacts enregistrés dans la base OneKey"
      }
    },
    "search_placeholder": {
      "firstname": "Rechercher par Prénom",
      "lastname": "Rechercher par Nom",
      "health_number": "Numéro professionnel"
    },
    "export_present_doctors_as_csv": "Télécharger la liste des médecins présents",
    "title": "Informations sur les invités",
    "subtitle": "Précisez les informations requises sur les invités.",
    "listTitle": "Liste de vos invités",
    "planned_amount": "Montant total des avantages prévus",
    "global_gap": "Écart des avantages",
    "actual_amount": "Montant total des dépenses réelles",
    "listHeader": {
      "id": "ID",
      "civility": "Civilité",
      "name_and_health_number": "Identité",
      "identity": "Identité",
      "name_and_specialty_and_health_number": "Nom, spécialité, numéro RPPS",
      "contact_infos": "Adresse",
      "contact_infos_tooltip": "Tri par code postal",
      "linked_ticket_code": "Manifestation liée",
      "contract_link": "Contrat lié",
      "type": "Typologie",
      "category": "Catégorie",
      "name": "Nom",
      "address": "Adresse postale",
      "email": "Adresse e-mail",
      "phone": "Tél",
      "lastname": "Nom",
      "firstname": "Prénom",
      "healthSpecialty": "Spécialité",
      "rppsNumber": "Numéro RPPS",
      "adeliNumber": "Numéro ADELI",
      "action": "Action",
      "packages": "Packs d'avantages",
      "planned_packages": "Packages prévus",
      "actual_packages": "Packages réels",
      "advantage": "Avantage",
      "planned_advantages": "Avantages prévus",
      "actual_advantages": "Dépenses réelles",
      "participation": "Participation",
      "is_billed": "Facturation",
      "total_advantage_amount": "Total avantages",
      "total_actual_advantage_amount": "Total des dépenses réelles",
      "is_present": "Participation",
      "is_threshold_reached": "Régime",
      "regime": "Régime social",
      "sign": "Signature",
      "title": "Titre",
      "state": "État",
      "contractual_link": "Lien contractuel",
      "sign_sent_date": "Date d'envoi signature",
      "signed_date": "Date de signature",
      "sign_reminder_date": "Date de relance",
      "file_type": "Type",
      "created_by": "Ajouté par",
      "added_by": "Ajouté par"
    },
    "legends": {
      "main": "Statut",
      "advantage": "Avantages",
      "identification": "Identification",
      "personal_information": "Informations personnelles",
      "representative": "Représentant",
      "attendees": "Invités",
      "validations": "Validations",
      "role": "Rôle",
      "contact": "Contact",
      "coordinates": "Adresse",
      "files": "Pièces jointes",
      "legal_information": "Informations juridiques"
    },
    "infos": {
      "lastname": "Nom",
      "firstname": "Prénom",
      "number": "Numéro",
      "legal_title": "Intitulé de la personne morale",
      "object_clause": "Objet Social",
      "description": "Objet Social",
      "company": "Société",
      "contractual_link": "Lien contractuel",
      "parent_organization_name": "Nom structure de rattachement",
      "health_number": "Numéro identifiant",
      "health_type": "Type de Professionnel de Santé",
      "healthSpecialties": "Spécialité",
      "phone_number": "Numéro de téléphone",
      "email": "E-mail",
      "type": "Typologie",
      "regime": "Régime",
      "is_public": {
        "label": "Agent public",
        "true": "Oui",
        "false": "Non",
        "public": "Agent public",
        "private": "Agent privé"
      },
      "is_military": {
        "label": "Militaire",
        "true": "Oui",
        "false": "Non"
      },
      "activity": "Activité principale",
      "type_number": "Type identifiant",
      "address": {
        "city": "Ville",
        "postcode": "Code postal",
        "street_name": "Adresse",
        "country": "Pays",
        "name": "Lieu d'exercice"
      },
      "title": {
        "label": "Titre",
        "PROFESSOR": "Professeur",
        "DOCTOR": "Docteur"
      },
      "is_threshold_reached": {
        "label": "Régime",
        "true": "Autorisation",
        "false": "Déclaration"
      },
      "acronym": "Acronyme",
      "legal_status": "Forme juridique",
      "rcs": "Numéro RCS",
      "place_of_registration": "Lieu d’enregistrement",
      "capital": "Capital",
      "prefecture_name": "Nom de la préfecture",
      "prefecture_number": "Numéro d’enregistrement à la préfecture",
      "base_global_code": "Code base globale",
      "ursaff_security_number": "N° URSSAF",
      "social_security_number": "N° Sécurité Sociale",
      "siret": "Siret",
      "prefecture_date": "Date d’enregistrement à la préfecture",
      "official_journal_date": "Date de parution au JO",
      "assignation": "Fonction",
      "external_id": "Code CRM"
    },
    "inputs": {
      "select_attendee": "1. Sélectionnez des invités via *",
      "data_source": {
        "label": "Source de données",
        "placeholder": "Source"
      },
      "is_threshold_reached": {
        "label": "Régime",
        "true": "Autorisation",
        "false": "Déclaration"
      },
      "civility": {
        "label": "Civilité",
        "MALE": "Monsieur",
        "FEMALE": "Madame",
        "UNKNOWN": "Inconnu",
        "male": {
          "name": "Monsieur",
          "short": "M.",
          "label": "Homme"
        },
        "female": {
          "name": "Madame",
          "short": "Mme",
          "label": "Femme"
        },
        "unknown": {
          "name": "Inconnu",
          "short": "",
          "label": "Inconnu"
        }
      },
      "files": {
        "default_placeholder": "Faites glisser ou cliquez pour télécharger"
      },
      "rib": {
        "label": "Rib",
        "placeholder": "Veuillez téléverser votre RIB"
      },
      "status": {
        "label": "Statuts",
        "placeholder": "Veuillez téléverser les statuts"
      },
      "official_journal": {
        "label": "Copie du Journal Officiel",
        "placeholder": "Veuillez téléverser la copie du Journal Officiel"
      },
      "solicitation_letter": {
        "label": "Lettre de sollicitation",
        "placeholder": "Veuillez téléverser la lettre de sollicitation"
      },
      "receipt": {
        "label": "Récépissé",
        "placeholder": "Veuillez téléverser le récépissé"
      },
      "category": {
        "label": "Statut",
        "HEALTH_PROFESSIONAL": "Professionnel de santé",
        "LEGAL_ENTITY": "Personne morale",
        "STUDENT": "Étudiant",
        "INFLUENCER": "Influenceur",
        "COLLABORATOR": "Collaborateur",
        "OTHER": "Autre non LEA"
      },
      "type": {
        "label": "Typologie",
        "AUDITOR": "Auditeur",
        "SPEAKER": "Intervenant/orateur",
        "SPEAKER_EXPERT": "Intervenant/expert",
        "SPEAKER_CONSULTANT": "Intervenant/consultant",
        "OTHER": "Autre",
        "INTERN": "Interne"
      },
      "title": {
        "label": "Titre",
        "PROFESSOR": "Professeur",
        "DOCTOR": "Docteur"
      },
      "state": {
        "label": "État",
        "PROSPECTIVE": "Pressenti",
        "ATTENDEE": "Confirmé",
        "NOT_SELECTED": "Non retenu",
        "NOT_SUBMITTED": "Non soumis"
      },
      "lastname": "Nom",
      "firstname": "Prénom",
      "health_type": {
        "label": "Type de Professionnel de Santé",
        "DENTIST": "Chirurgien-Dentiste",
        "DIETITIAN": "Diététicien",
        "DOCTOR": "Médecin",
        "HEAR_AID_SPECIALIST": "Audioprothésiste",
        "LABORATORY_TECHNICIAN": "Technicien de laboratoire médical",
        "MASSAGE_THERAPIST": "Masseur-Kinésithérapeute",
        "MEDICAL_ELECT_RADIO_MANIPULATOR": "Manipulateur ERM",
        "MIDWIFE": "Sage-Femme",
        "NURSE": "Infirmier",
        "OCCUPATIONAL_THERAPIST": "Ergothérapeute",
        "ORTHOPTIST": "Orthoptiste",
        "PHARMACIST": "Pharmacien",
        "PODIATRIST": "Pédicure-Podologue",
        "PSYCHOMOTRICIAN": "Psychomotricien",
        "SPEECH_THERAPIST": "Orthophoniste",
        "ORTHOPEDIST_ORTHOTIST": "Orthopédiste-Orthésiste",
        "OCULARIST": "Oculariste",
        "ORTHOPROSTHETIST": "Orthoprothésiste",
        "PODO_ORTHOTIST": "Podo-Orthésiste",
        "EPITHESIST": "Epithésiste",
        "CARE_GIVER": "Soignant / Aide-soignant",
        "CHILD_CARE_ASSISTANT": "Auxiliaire de Puériculture",
        "DENTAL_ASSISTANT": "Assistant(e) Dentaire",
        "MEDICAL_PHYSICIST": "Physicien(ne) Médical(e)",
        "OPTICIAN_EYE_WEAR": "Opticien(ne) / Lunetier(ière)",
        "OTHER": "Autre",
        "PARAMEDIC": "Ambulancier(ère) / Paramédical(e)",
        "PHARMACY_HOSPITAL_PREPARER": "Préparateur(trice) en Pharmacie / Pharmacie Hospitalière",
        "OFFICINE_PHARMACY_PREPARER": "Préparateur(trice) en Pharmacie Officine",
        "HOSPITAL_PHARMACY_PREPARER": "Préparateur(trice) en Pharmacie Hospitalière",
        "PROTHETHIST_ORTHOTIST_DISABLED": "Prothésiste et Orthésiste pour l'appareillage des personnes handicapées",
        "VETERINARY": "Vétérinaire",
        "CHIROPRACTOR": "Chiropracteur",
        "OSTEOPATH": "Ostéopathe",
        "PSYCHOTHERAPIST": "Psychothérapeute"
      },
      "health_specialty": {
        "label": "Spécialité"
      },
      "medical_type": {
        "label": "Types de professionnels de santé invités",
        "DENTAL_SURGEON": "Chirurgiens dentistes",
        "NURSE": "Infirmiers",
        "DOCTOR": "Médecins",
        "MIDWIFE": "Sages-femmes",
        "MILITARY_PERSONNEL": "Militaires",
        "PODIATRIST": "Pédicures-Podologues",
        "PHYSICAL_THERAPIST": "Masseurs-Kinésithérapeutes",
        "HOSPITAL_PHARMACIST": "Pharmaciens hospitaliers",
        "COMMUNITY_PHARMACIST": "Pharmaciens d'officine",
        "MINE_MUTUAL_PHARMACIST": "Pharmaciens mines/mutualistes",
        "BIOLOGICAL_PHARMACIST": "Pharmaciens biologistes",
        "OVERSEAS_PHARMACIST": "Pharmaciens d'Outre-mer",
        "WHOLESALE_PHARMACIST": "Pharmaciens grossistes"
      },
      "pharmacist_type": {
        "label": "Type de pharmacien",
        "PHARMACISTS_COMMUNITY": "Pharmaciens titulaires d'officine (section A)",
        "PHARMACISTS_INDUSTRY": "Pharmaciens de l'industrie (section B)",
        "PHARMACISTS_WHOLESALER": "Pharmaciens de la distribution en gros (section C)",
        "PHARMACISTS_ASSISTANT_AND_OTHERS": "Pharmaciens adjoints d'officine et autres exercices (section D)",
        "PHARMACISTS_OVERSEAS_DEPARTMENTS_AND_TERRITORIES": "Pharmaciens des départements et collectivités d'outre-mer (section E)",
        "PHARMACISTS_LIBERAL_AND_HOSPITAL_BIOLOGIST": "Pharmaciens biologistes libéraux et hospitaliers (section G)",
        "PHARMACISTS_HEALTHCARE_INSTITUTIONS": "Pharmaciens des établissements de santé (section H)"
      },
      "number": "Numéro",
      "contractual_link": {
        "label": "Lien contractuel",
        "BENEFICIAL_OWNER_NON_SIGNATORY": "Bénéficiaire final non signataire",
        "CONTRACTOR": "Contractant",
        "NON_BENEFICIAL_OWNER_CONTRACTOR": "Contractant non bénéficiaire"
      },
      "executive_role": {
        "label": "Fonction",
        "PRESIDENT": "Président",
        "DIRECTOR": "Directeur",
        "TREASURER": "Trésorier",
        "SECRETARY": "Secrétaire"
      },
      "organization_type": {
        "label": "Type d'organisme",
        "ACADEMY": "Académie",
        "FOUNDATION": "Fondation",
        "LEARNED_SOCIETY": "Société savante",
        "ADVISORY_BODY": "Organisme de conseils",
        "HEALTHCARE_PROFESSIONAL_ASSOCIATION": "Association de professionnels de santé",
        "STUDENT_ASSOCIATION": "Association d'étudiants",
        "HEALTHCARE_SYSTEM_USER_ASSOCIATION": "Association d'usagers du système de santé",
        "SOFTWARE_PUBLISHER": "Éditeur de logiciel",
        "HEALTHCARE_FACILITY": "Établissement de santé",
        "AGRICULTURAL_PROFESSIONAL_GROUP": "Groupement professionnel agricole",
        "HEALTH_GROUP": "Groupement sanitaire",
        "HEALTHCARE_EDUCATION_INSTITUTION": "Personne morale assurant la formation initiale ou continue des professionnels de santé",
        "PRESS_AND_MEDIA": "Presse et média",
        "CORPORATE_VETERINARY": "Vétérinaire personne morale",
        "OTHER": "Autre"
      },
      "legal_title": "Intitulé de la personne morale",
      "legal_title_and_acronym": "Intitulé / Acronyme",
      "object_clause": "Objet Social",
      "object_clause_tooltip": "255 caractères max pour les soumissions aux ordres",
      "description": "Objet Social",
      "company": "Société",
      "parent_organization_name": "Nom structure de rattachement",
      "health_number": "Numéro identifiant",
      "city": "Ville",
      "postcode": "Code postal",
      "street_name": "Adresse",
      "country": "Pays",
      "add": "Ajouter",
      "modify": "Modifier",
      "address": "Adresse postale",
      "address_name": "Lieu d'exercice",
      "phone_number": "Numéro de téléphone",
      "email": "E-mail",
      "legal_status": "Forme juridique",
      "rcs": "Numéro RCS",
      "place_of_registration": "Lieu d’enregistrement",
      "capital": "Capital",
      "acronym": "Acronyme",
      "prefecture_name": "Nom de la préfecture",
      "prefecture_number": "Numéro d’enregistrement à la préfecture",
      "base_global_code": "Code base globale",
      "ursaff_security_number": "N° URSSAF",
      "social_security_number": "N° Sécurité Sociale",
      "siret": "Siret",
      "prefecture_date": "Date d’enregistrement à la préfecture",
      "official_journal_date": "Date de parution au JO",
      "regime": {
        "label": "Régime",
        "NON_URSSAF": "Non URSSAF",
        "URSSAF": "URSSAF"
      },
      "is_public": {
        "label": "Agent public",
        "true": "Oui",
        "false": "Non",
        "public": "Agent public",
        "private": "Agent privé"
      },
      "is_military": {
        "label": "Militaire",
        "true": "Oui",
        "false": "Non"
      },
      "activity": {
        "label": "Activité principale",
        "PUPH": "PUPH",
        "HOSPITAL_UNI_NOT_PUPH": "Hospitalo-Universitaire non PUPH",
        "HOSPITAL_FULL_TIME": "Hospitalier temps plein / Salarié de l'état / Salarié PSPH",
        "HOSPITAL_PART_TIME": "Hospitalier temps partiel",
        "LIBERAL": "Libéral / Salarié du privé",
        "RETIRED": "Retraités",
        "INTERN": "Interne"
      },
      "type_number": {
        "label": "Type identifiant",
        "ADELI": "ADELI",
        "INE": "INE",
        "RPPS": "RPPS",
        "OTHER": "Autre",
        "RNA": "RNA"
      },
      "code_crm": "Code CRM",
      "assignation": "Fonction",
      "submission_regime": {
        "AUTHORIZATION": "Autorisation",
        "DECLARATION": "Déclaration"
      },
      "adeli_number": "Numéro ADELI",
      "rpps_number": "Numéro RPPS"
    },
    "modal": {
      "title": "Édition invité - Non Retenu",
      "description": "La modification de l’état de l’invité en “non retenu” supprimera le pack attribué de l’invité.",
      "validation": "Souhaitez-vous enregistrer vos modifications ?"
    },
    "error": {
      "default": "Une erreur s'est produite veuillez réessayer plus tard",
      "excel_file": "Veuillez sélectionner un fichier Excel.",
      "data_import_fail": "Certaines valeurs n'ont pas pu être enregistrées."
    },
    "delete_multiple_attendees": "Supprimer {count} invités",
    "delete_attendees_modal": {
      "title": "Confirmation de suppression",
      "description_multiple": "Êtes-vous sûr de vouloir supprimer les {count} invités sélectionnés ?",
      "description_single": "Êtes-vous sûr de vouloir supprimer l'invité :",
      "validate": "Valider"
    }
  },
  "advantages": {
    "advantages": "Avantages",
    "title": "Fill your advantages",
    "subtitle": "Specify the required benefit information.",
    "create_advantages": "Créer avantages",
    "amount": "Montant",
    "amounts": "Montants",
    "comment": "Commentaire",
    "area": "Superficie",
    "excluding_tax_amount": "Montant HT",
    "gross_amount": "Montant brut",
    "including_tax_amount": "Montant TTC",
    "net_amount": "Montant net",
    "slice": "Tranche",
    "add_amount": "Ajouter un montant",
    "remove_amount": "Supprimer un montant",
    "add_advantage": "Ajouter un avantage",
    "edit_advantage": "Éditer l'avantage",
    "create_pack": "Création du Pack",
    "update_pack": "Mise à jour du Pack",
    "pack_info": "Information du pack",
    "pack_name": "Nom du pack",
    "quantity": "Quantité",
    "advantage_type": "Type d'avantages",
    "select_pack": "Veuillez sélectionner un pack.",
    "payment_date": "Date de paiement",
    "missing_payment_date": {
      "title": "Date de paiement manquante",
      "description": "Les packs suivants contiennent des avantages sans date de paiement :",
      "back_button": "Accéder à la saisie des dépenses"
    },
    "modal": {
      "title": "Invité non facturé",
      "description": "L’attribution d’un pack de dépenses réelles aux invités non facturés est impossible. Souhaitez-vous modifier votre feuille d’émargement ?",
      "button": "Accéder à la feuille d'émargement"
    },
    "per_hour": {
      "preparation": "Nombre d’heures de préparation",
      "intervention": "Nombre d’heures d’intervention"
    },
    "per_half_day": {
      "preparation": "Nombre de demi-journées de préparation",
      "intervention": "Nombre de demi-journées d’intervention"
    },
    "per_day": {
      "preparation": "Nombre de journées de préparation",
      "intervention": "Nombre de journées d’intervention"
    },
    "type": {
      "EQUIPMENT_LOAN": "Prêt de matériel",
      "HOSPITALITY_MEAL": "Hospitalité repas",
      "HOSPITALITY_LUNCH": "Hospitalité déjeuner",
      "HOSPITALITY_DINNER": "Hospitalité diner",
      "HOSPITALITY_NIGHT": "Hospitalité nuit",
      "HOSPITALITY_SNACK": "Hospitalité collation",
      "HOSPITALITY_TRAVEL": "Hospitalité transport",
      "SALARY_AGREEMENT": "Rémunération total convention",
      "SALARY_HALF_DAY_PREPARATION": "Rémunération demi-journée - préparation",
      "SALARY_HOURLY_PREPARATION": "Rémunération heure - préparation",
      "SALARY_DAY_PREPARATION": "Rémunération jour - préparation",
      "SALARY_HALF_DAY_INTERVENTION": "Rémunération demi-journée - intervention",
      "SALARY_HOURLY_INTERVENTION": "Rémunération heure - intervention",
      "SALARY_DAY_INTERVENTION": "Rémunération jour - intervention",
      "TRAINING": "Frais de formation",
      "REGISTRATION_FEE": "Frais d'inscription",
      "STAND_RENTAL": "Location de stand",
      "BOOK": "Ouvrage",
      "SUPPLY": "Fourniture",
      "SAMPLE": "Échantillon",
      "DONATION_OR_LOAN_FOR_TRAINING": "Don ou prêt pour la formation",
      "MATERIAL_DONATION": "Don de matériel",
      "SAMPLE_DONATION": "Don d’échantillons",
      "BOOK_DONATION": "Don d’ouvrages",
      "DONATION_OR_LOAN_FOR_RESEARCH": "Don ou prêt pour la recherche",
      "OPERATING_DONATION": "Don de fonctionnement",
      "OTHER_PRODUCTS_AND_SERVICES": "Autres produits et services",
      "OTHER": "Autre",
      "CLINICAL_STUDY": "Rémunération étude clinique"
    },
    "detail": "Informations complémentaires",
    "browse_packs": "Parcourir les packs existants",
    "browse_actual_packs": "Parcourir les packs réels",
    "actual": {
      "tabs": {
        "attribution": "Attribution des avantages réels",
        "detailed_distribution": "Répartition détaillée",
        "import_expenses": "Import dépenses réelles",
        "additional_costs": "Frais annexes",
        "expense_report": "Justificatifs"
      }
    },
    "clone_planned_packs": "Cloner les packs prévus",
    "assign_planned_packs": "Attribuer les packs prévus",
    "select_packs": "Packs disponibles",
    "create_advantage": "Création d'un avantage",
    "modify_amounts": "Modification des montants",
    "is_present": "Présent",
    "not_present": "Absent",
    "is_billed": "Facturé",
    "not_billed": "Non facturé",
    "is_threshold_reached": {
      "authorization": "Autorisation",
      "declaration": "Déclaration"
    },
    "popup_modal": {
      "replace_pack": {
        "title": "Remplacement pack d'avantage",
        "warning": "Un pack d'avantage est attribué à cet/ces invité(s). Souhaitez-vous remplacer le pack existant ?"
      }
    }
  },
  "contract_template": {
    "list_title": "Modèles de contrat",
    "document_name": "Nom du modèle de contrat",
    "download": "Téléverser un modèle de contrat",
    "attendees": "Liste d'invités",
    "uploaded_contract": "Modèle de contrat ajouté",
    "signature_request_type_row": {
      "UNORDERED": "Parallèle",
      "ORDERED": "Séquentielle",
      "TRIPARTITE_ORDERED": "Tripartite séquentielle",
      "TRIPARTITE_UNORDERED": "Tripartite parallèle",
      "MANUAL": "Manuelle"
    },
    "signature_request_type": {
      "label": "Procédure de signature",
      "UNORDERED": "Signature parallèle",
      "ORDERED": "Signature séquentielle",
      "TRIPARTITE_ORDERED": "Signature tripartite séquentielle",
      "TRIPARTITE_UNORDERED": "Signature tripartite parallèle"
    },
    "alert": {
      "title": "Procédure de signature de contrats",
      "description": "Attention, le champ E-mail, obligatoire pour l’envoi des contrats, est incomplet pour certains invités.",
      "confirmation": "Souhaitez-vous envoyer la procédure de signature pour les invités complets ?",
      "email_mandatory": "Le champ E-mail est obligatoire pour l’envoi des contrats.",
      "email_missing": "Email manquant",
      "authorization_document_missing": "Document de demande d’autorisation de cumul d’activité est manquant",
      "email_and_authorization_document_missing": "Email et document de demande d’autorisation de cumul d’activité est manquant",
      "cancel": "Compléter le(s) champ(s)",
      "send": "Envoyer"
    }
  },
  "signing_sheet": {
    "title": "Feuille d'émargement",
    "sign": "Signatures",
    "attendees_list": "Liste des invités",
    "to_sign": "Signer la feuille d'émargement",
    "to_submit_and_next_step": "Enregistrer et envoyer à l’étape suivante",
    "generate": "Génération",
    "actions": "Actions",
    "download_upload": "Télécharger/Téléverser",
    "tab": {
      "label": {
        "report": "Participation/Facturation",
        "signing": "Émargement électronique",
        "download": "Émargement manuel"
      }
    },
    "document_name": "Feuille d'émargement",
    "generate_signed_sheet": "Générer une feuille d'émargement signée",
    "generate_virgin_sheet": "Générer une feuille d'émargement vierge",
    "upload_manually_signed_sheet": "Téléverser une feuille d'émargement signée manuellement",
    "download": "Téléverser feuille d’émargement",
    "uploaded_sheet": "Feuilles émargement ajoutées ",
    "consent": "J’atteste avoir pris connaissance des informations relatives à la collecte de mes données personnelles",
    "hospitality": "Avec hospitalité",
    "delete": "Supprimer la signature",
    "existing_signature": "Signature enregistrée",
    "sign_off_sheet": "Feuille d'émargement",
    "history_export": "Historique",
    "listHeader": {
      "sign": "Signatures",
      "identity": "Identité",
      "filename": "Nom du fichier",
      "generated_at": "Date de génération",
      "created_at": "Créé le",
      "actions": "Actions"
    },
    "download_template_modal": {
      "title": "Télécharger la feuille d'émargement",
      "options": {
        "title": "Format de téléchargement",
        "pdf": {
          "title": "PDF",
          "description": "Télécharger la feuille d'émargement en format PDF"
        },
        "docx": {
          "title": "DOCX",
          "description": "Télécharger la feuille d'émargement en format DOCX"
        },
        "xlsx": {
          "title": "XLSX",
          "description": "Télécharger la feuille d'émargement en format XLSX"
        }
      },
      "button": {
        "validate": "Valider"
      }
    }
  },
  "expense_report": {
    "title": "Justificatifs",
    "add": "Ajout des justificatifs",
    "document_name": "Justificatifs",
    "inputs": {
      "name": {
        "label": "Justificatifs",
        "placeholder": "Veuillez renseigner un titre à votre justificatif"
      }
    },
    "reference": "Référence de paiement",
    "download": "Téléverser un justificatif",
    "uploaded_report": "Justificatifs ajoutées",
    "listHeader": {
      "filename": "Nom du fichier",
      "report": "Justificatifs",
      "reference": "Référence de paiement",
      "actions": "Actions"
    }
  },
  "non_compliance": {
    "title": "Non conformité",
    "add": "Ajout de non conformités",
    "input_type": "Type de non conformité",
    "input_internal_code": "Code interne",
    "item_list": "Liste des non conformités",
    "listHeader": {
      "non_compliance_type": "Type de non conformité",
      "code": "Code"
    },
    "error": {
      "default": "Une erreur s'est produite veuillez réessayer plus tard"
    }
  },
  "post_event_action": {
    "title": "Actions Post évènement",
    "download_history": "Télécharger l'historique",
    "to_archive": "Archiver le ticket",
    "to_declare": "Envoyer en Transparence Santé",
    "to_edit_advantages": "Saisie dépenses",
    "modal": {
      "warning_archive": "Vous allez archiver ce ticket",
      "warning_declare": "Aucune déclaration sur Transparence Santé ne sera possible par la suite."
    },
    "tabs": {
      "attendance_sheet": "Feuille d'émargement",
      "expense_report": "Note de frais",
      "noncompliance": "Non conformité",
      "documents": "Documents"
    }
  },
  "validation": {
    "attendee": {
      "empty_email": "Veuillez renseigner l’adresse mail de tous les invités"
    },
    "attachment": {
      "empty_attachment": "Veuillez ajouter une pièce jointe"
    }
  },
  "history": {
    "title": "Historique pour le ticket {ticketCode}",
    "header": "Événement",
    "search_placeholder": "Rechercher par nom / prénom"
  },
  "additional_costs": {
    "listHeader": {
      "type": "Type de frais annexe",
      "amount": "Montant",
      "description": "Note",
      "action": "Actions"
    },
    "title": "Frais annexes",
    "create_cost": "Nouveau frais annexe",
    "edit_cost": "Édition de frais annexe",
    "inputs": {
      "type": {
        "label": "Type de frais",
        "placeholder": "Veuillez renseigner un titre à votre frais annexe"
      },
      "amount": "Montant",
      "description": "Note"
    },
    "total_additional": "Total frais annexes",
    "total_ticket": "Total ticket"
  },
  "infos_page": {
    "event_informations": "Informations évènement",
    "bot_informations": "Informations dépôt BOT",
    "general_informations": "Informations",
    "attendee": "Invités",
    "advantage": "Avantages",
    "attachments_header": "Pièces jointes",
    "manually_signed_sheets": {
      "attendees": "Feuilles d'émargement - Invités",
      "advantages": "Pièces jointes - Avantages",
      "types": {
        "expenses": "Justificatifs",
        "manual": "Émargement manuel"
      }
    },
    "generate_sign_in_sheet": "Générer une feuille d'émargement",
    "attachments_table": {
      "file_name": "Nom du fichier",
      "comment": "Commentaire",
      "type": "Type",
      "action": "Action"
    },
    "attachments": "Pièces jointes ajoutées",
    "attendee_informations": {
      "title": "Informations invité",
      "joined_files": "Fichiers joints",
      "attachments": "Documents joints",
      "no_joined_files": "Aucun fichier disponible,",
      "no_generated_contracts": "Aucun contrat généré,",
      "can_you": "vous pouvez en",
      "upload_generated_contracts": "générer ici.",
      "upload_joined_files": "téléverser ici."
    },
    "details": {
      "description": "Description",
      "event_type": "Type de la manifestation",
      "code": "Numéro de dossier interne",
      "workflow_name": "Nom du flux interne",
      "creator": "Créateur du ticket",
      "initiator": "Initiateur",
      "validator_1": "Validateur 1",
      "validator_2": "Validateur 2"
    },
    "deposit": {
      "details": {
        "initiator": "Initiateur de la soumission",
        "recipient": "Destinataire",
        "date": "Date et Heure de la dernière soumission",
        "list": "Liste des soumissions BOT"
      },
      "submission": {
        "type": {
          "MANUAL": "Manuel",
          "BOT": "Bot"
        }
      },
      "header": {
        "reference": "REF SOUMISSION",
        "date": "Date d'exécution du bot",
        "status": "STATUT",
        "link": "Lien soumission",
        "json_logs": "JSON",
        "initiator": "Initiateur",
        "logs": "LOGS",
        "packages": "Pack",
        "references": "References",
        "attachments": "Nom de la pièce jointe",
        "type": "type",
        "action": "Action"
      }
    }
  },
  "deposit_management_page": {
    "idahe": "IDAHE 2",
    "eps": "EPS",
    "other": "Autre",
    "regime": "Régime - {regime}",
    "deposit_disclosure": "Dépôt {0}",
    "documents_download_modal": {
      "title": "Télécharger les documents dépôt manuel",
      "description": "Quels documents souhaitez-vous télécharger ?",
      "pdf": {
        "title": "PDF fusionnés",
        "description": "d’une version fusionnées des contrats {type}."
      },
      "csv": {
        "title": "CSV",
        "description": "Téléchargement de la liste CSV des médecins au format .csv"
      },
      "archive": {
        "title": "PDF individuels",
        "description": "Téléchargement d’un zip avec tous les contrats {type} individuellement."
      },
      "type": {
        "declaration": "signé",
        "authorization": "non signé"
      },
      "no_generated_template": "Aucun fichier généré",
      "generated_at": "Fichier généré le: ",
      "completed": {
        "title": "La génération des documents est terminée",
        "label": "Accéder aux documents"
      },
      "processing": {
        "title": "La génération des documents est en cours",
        "message": "Vous pouvez continuer à naviguer sur le site en attendant la fin de la génération"
      },
      "failed": {
        "title": "Une erreur est survenue lors de la génération des documents",
        "description": "Veuillez réessayer plus tard."
      },
      "button": {
        "validate": "Valider",
        "generate_eps": {
          "DECLARATION": "Contrat(s) signé(s)",
          "AUTHORIZATION": "Contrat(s) non signé(s)"
        },
        "generate": "Générer",
        "download": "Télécharger"
      }
    },
    "no_attendees": "Ce pack n'est attribué à aucun invité",
    "listHeader": {
      "title": "Titre",
      "status_sign": "Status Signature",
      "status_deposit": "Status Dépôt",
      "document_type": "Type de document",
      "identity": "Identité",
      "contact_infos": "Adresse",
      "sign": "Signature",
      "package": "PACK AVANTAGE",
      "regime": "Régime",
      "deposit": "Dépôt",
      "actions": "Actions",
      "created_by": "Ajouté par"
    },
    "regional_health_agency": "Agence régionale de santé",
    "other_category": {
      "MILITARY_SERVICE": "Service des Armées",
      "MONACO_MEDICAL_COUNCIL": "Conseil de l'Ordre des Médecins de Monaco",
      "MONACO_PHARMACY_COUNCIL": "Conseil de l'Ordre des Pharmaciens de Monaco"
    },
    "no_reference": "Aucune référence",
    "modal": {
      "title": "Le dépôt sélectionné existe déjà",
      "body": "Souhaitez-vous réaliser une nouvelle soumission de ce dépôt ?"
    },
    "badge": {
      "declaration_sent": "Déclaration envoyée",
      "authorization_sent": "En attente de la notification de dossier complet",
      "failed": "Échec du bot",
      "pending": "Envoi en cours",
      "not_sent": "À envoyer",
      "convention_authorized": "Convention autorisée",
      "convention_refused": "Convention non autorisée",
      "submission_incomplete": "Dossier incomplet",
      "validation_pending": "En attente de l’autorisation",
      "waiting_for_notification": "En attente de la notification du dossier complet",
      "submission_sent": "Soumission envoyée",
      "canceled": "Annulé"
    },
    "input": {
      "export_as_csv": "Générer la liste des médecins",
      "download": "CSV des médecins et contrat(s)"
    }
  },
  "deposit": {
    "slideover": {
      "title": "Éditer une référence",
      "edit": "Modifier",
      "cancel": "Annuler",
      "submited_at": "Soumission créée le : {date}",
      "input": {
        "reference": {
          "label": "Référence",
          "placeholder": "Renseignez la référence de la soumission"
        },
        "url": {
          "label": "URL",
          "placeholder": "Renseignez l'URL de la soumission"
        },
        "comment": {
          "label": "Commentaires",
          "placeholder": "Commentaires"
        },
        "file_type": {
          "label": "Type de fichier",
          "placeholder": "Renseignez le type de fichier"
        },
        "incomplete_submission_date": "Date de notification de dossier incomplet",
        "authorization_refusal_date": "Date de réception d’un refus d’autorisation",
        "recommendation_date": "Date de réception d’une recommandation",
        "status": "Statut de la soumission",
        "attachments": "Veuillez téléverser un document de soumission",
        "acceptation_date": "Date de réception d'acceptation",
        "complete_submission_date": "Date de réception de dossier complet",
        "additional_information": {
          "label": "Information complémentaire",
          "placeholder": "Information complémentaire"
        },
        "submission_date": "Date de soumission"
      }
    },
    "DECLARATION": "Déclaration",
    "AUTHORIZATION": "Autorisation",
    "submission_list": "Liste des soumissions BOT",
    "status": {
      "DONE": "Succès",
      "FAILED": "Échec",
      "PENDING": "En cours",
      "CONVENTION_AUTHORIZED": "Convention autorisée",
      "CONVENTION_REFUSED": "Convention non autorisée",
      "SUBMISSION_INCOMPLETE": "Dossier incomplet",
      "VALIDATION_PENDING": "En attente de l’autorisation",
      "CANCELED": "Annulée",
      "RECOMMENDATION_PENDING": "En attente de la recommandation",
      "SUBMISSION_SENT": "Soumission envoyée",
      "WAITING_FOR_NOTIFICATION": "En attente de la notification du dossier complet "
    },
    "submission": {
      "status": {
        "DONE": "Succès",
        "FAILED": "Échec",
        "PENDING": "En cours",
        "CONVENTION_AUTHORIZED": "Convention autorisée",
        "CONVENTION_REFUSED": "Convention non autorisée",
        "SUBMISSION_INCOMPLETE": "Dossier incomplet",
        "VALIDATION_PENDING": "En attente de l’autorisation",
        "CANCELED": "Annulée",
        "RECOMMENDATION_PENDING": "En attente de la recommandation",
        "SUBMISSION_SENT": "Soumission envoyée",
        "WAITING_FOR_NOTIFICATION": "En attente de la notification du dossier complet "
      },
      "document_type": {
        "SUBMISSION_LETTER": "Courrier de soumission",
        "SUBMISSION_LETTER_COMPLEMENT": "Courrier de soumission - Complément d'information",
        "SUBMISSION_LETTER_MODIFICATION": "Courrier de soumission - Modification",
        "PS_LETTER_CANCEL": "Courrier PS d'annulation",
        "PS_LETTER_MAINTAIN": "Courrier PS de maintien",
        "SUPPLEMENT_INFO_REQUEST": "Demande de complément d'information reçue",
        "NOTICE_FROM_ORDER": "Avis de l'ordre",
        "SIGNED_CONVENTION": "Conventions Signées",
        "UNSIGNED_CONVENTION": "Conventions Non Signées",
        "ATTENDEE_LIST": "Liste des invités - CSV",
        "CONTRACTS": "Contrats",
        "OTHER": "Autre",
        "ZIP": "ZIP pour dépôt manuel"
      }
    },
    "titles": {
      "other_documents": "Pièces jointes générées",
      "uploaded_documents": "Pièces jointes téléversées"
    },
    "recipient": {
      "MILITARY": "Service de Santé des Armées",
      "NURSE": "Conseil National de l'Ordre des infirmiers",
      "DOCTOR": "Conseil National de l'Ordre des Médecins",
      "MASSAGE_THERAPIST": "Conseil National de l'ordre des Masseurs Kinésithérapeutes",
      "MIDWIFE": "Conseil National de l'Ordre des Sages-femmes",
      "DENTIST": "Conseil National de l'Ordre des Chirurgiens-Dentistes",
      "PODIATRIST": "Conseil National de l'Ordre des Pédicures-Podologues",
      "PHARMACISTS_COMMUNITY": "Conseil National de l'Ordre des Pharmaciens Section Officine",
      "PHARMACISTS_INDUSTRY": "Conseil National de l'Ordre des Pharmaciens Section Mines",
      "PHARMACISTS_WHOLESALER": "Conseil National de l'Ordre des Pharmaciens Section Grossistes",
      "PHARMACISTS_ASSISTANT_AND_OTHERS": "Conseil National de l'Ordre des Pharmaciens Section Adjoint",
      "PHARMACISTS_OVERSEAS_DEPARTMENTS_AND_TERRITORIES": "Conseil National de l'Ordre des Pharmaciens Section Outre-Mer",
      "PHARMACISTS_LIBERAL_AND_HOSPITAL_BIOLOGIST": "Conseil National de l'Ordre des Pharmaciens Section Biologie",
      "PHARMACISTS_HEALTHCARE_INSTITUTIONS": "Conseil National de l'Ordre des Pharmaciens Section Hôpital",
      "REGIONAL_HEALTH_AGENCY": "Agence régionale de santé",
      "NONE": "Aucun",
      "MILITARY_SERVICE": "Service des Armées",
      "MONACO_MEDICAL_COUNCIL": "Conseil de l'Ordre des Médecins de Monaco",
      "MONACO_PHARMACY_COUNCIL": "Conseil de l'Ordre des Pharmaciens de Monaco"
    }
  },
  "transparency": {
    "view": "Consulter le ticket"
  },
  "submission_regime": {
    "NONE": "Aucun régime",
    "DECLARATION": "Déclaration",
    "AUTHORIZATION": "Autorisation",
    "MIXED": "Mixte"
  },
  "remaining_submission": {
    "day": "{nb} jour restant",
    "days": "{nb} jours restants",
    "over_one_year": "+365 jours restants"
  },
  "overdue_submission": {
    "day": "Dépassé de 1 jour",
    "days": "Dépassé de {nb} jours",
    "over_one_year": "Dépassé de +365 jours"
  },
  "filter": {
    "status": {
      "label": "Statut",
      "values": {
        "archived": "Archivé",
        "canceled": "Annulé",
        "published": "Publié"
      }
    }
  },
  "attendees_import": {
    "breadcrumb": {
      "attendee_by_import_list": "Importation des invités",
      "edit": "Édition"
    },
    "title": "Liste des importations des invités",
    "header": {
      "status": "Status",
      "created_at": "Créé le",
      "action": "Actions"
    },
    "status": {
      "SUCCESS": "Succès",
      "WARNING": "Attention données manquantes",
      "FAILED": "Échec"
    }
  },
  "actual_details_list": {
    "title": "Détails des avantages",
    "view_detail": "Voir le détail",
    "reduce_detail": "Réduire",
    "attribution_of_benefits": "Attribution des avantages",
    "detailed_distribution": "Répartition détaillée",
    "header": {
      "advantage_type": "Avantages",
      "total_planned_advantages": "Prévisionnels",
      "total_actual_advantages": "Réels",
      "total_gap": "Écart"
    },
    "attendee_header": {
      "identity": "Identité",
      "status": "Statut",
      "total_advantages": "Total avantages",
      "participation": "Participation",
      "is_billed": "Facturation"
    }
  },
  "watchdogs": {
    "disclosures": {
      "only_first_15_occurrences": "Seuls les 15 premiers éléments seront affichés"
    }
  }
}
